var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWatchVideoIcon = function SvgWatchVideoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0047ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.75,17.25h.43a3.82,3.82,0,0,1,1.15-1.31l.23-.13A2.46,2.46,0,0,1,9,14.25a2.5,2.5,0,0,1,5,0,2.46,2.46,0,0,1-.56,1.56l.23.13a3.82,3.82,0,0,1,1.15,1.31h3.43V8.75H7.75ZM9.25,9.5h7.5a.76.76,0,0,1,.75.75v5.5a.75.75,0,0,1-1.5,0V11H9.25a.75.75,0,0,1,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm6.75,17.5a1.12,1.12,0,0,1-.1.48,1.27,1.27,0,0,1-.67.67,1.12,1.12,0,0,1-.48.1H14.33a.76.76,0,0,1-.71-.5,2.22,2.22,0,0,0-.82-1.09,2.29,2.29,0,0,0-2.6,0,2.22,2.22,0,0,0-.82,1.09.76.76,0,0,1-.71.5H7.5a1.12,1.12,0,0,1-.48-.1A1.27,1.27,0,0,1,6.35,18a1.12,1.12,0,0,1-.1-.48v-9A1.26,1.26,0,0,1,7.5,7.25h11A1.26,1.26,0,0,1,19.75,8.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 14.25,
    r: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatchVideoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WatchVideoIcon.bf45bdff.svg";
export { ForwardRef as ReactComponent };